import { gql } from '@apollo/client';

export const LIST_ORGANIZATION_TYPES = gql`
  query listOrganizationTypes {
    listOrganizationTypes
  }
`;
